// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.previewOrders_header__hz7Ou {
  display: flex;
  flex-direction: column;
  justify-content: space-between; }
  .previewOrders_header__settings__zOySh {
    margin-left: 7px;
    color: #666666;
    cursor: pointer;
    transition: all 0.4s linear;
    width: 32px;
    height: 32px; }
    .previewOrders_header__settings__zOySh:hover {
      color: black; }
  .previewOrders_header_title__yWbcc {
    font-weight: 600;
    font-size: 32px;
    line-height: 150%;
    color: var(--HightEmphasis); }
  .previewOrders_header_container__F4tm7 {
    display: flex; }
    .previewOrders_header_container_date__f4fdX {
      margin-left: 10px;
      padding-right: 30px; }
    .previewOrders_header_container_filters__NIu4I {
      display: flex;
      align-items: center;
      gap: 10px; }

.previewOrders_body__4D2dY {
  height: calc(100vh - 190px);
  display: flex;
  flex-direction: column;
  padding: 20px 0 0 0;
  gap: 10px; }
  .previewOrders_body_error__kkmbc {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px; }
    .previewOrders_body_error_title__g0Fqa {
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      color: var(--HightEmphasis); }
    .previewOrders_body_error_icon__Chfth {
      color: var(--LowEmphasis); }
    .previewOrders_body_error_subtitle__x\\+Zf8 {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      color: var(--MediumEmphasis);
      text-align: center;
      max-width: 320px; }
      .previewOrders_body_error_subtitle_link__GUpka {
        text-decoration: none;
        color: var(--Orange); }

.previewOrders_error__oQaFU {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 36px; }

@media (min-width: 768px) {
  .previewOrders_content__DnChL .previewOrders_header__hz7Ou {
    flex-direction: row; } }

@media (min-width: 1024px) {
  .previewOrders_content__DnChL .previewOrders_body__4D2dY {
    flex-direction: row; } }

.previewOrders_menu__glqXY {
  top: 0;
  right: 0;
  height: 100vh;
  width: 35vw;
  position: relative;
  background-color: #be8b7b;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: 10rem 0;
  transition: transform 0.3s ease-in-out; }
  @media (max-width: 600px) {
    .previewOrders_menu__glqXY {
      width: 100%; } }

.previewOrders_tabs1__Lnnk2 {
  position: relative;
  display: flex;
  gap: 20px; }

.previewOrders_tab__oZOox {
  padding: 15px 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  text-decoration: none;
  transition: all 0.4s; }
  .previewOrders_tab__oZOox span {
    transition: all 0.4s; }

.previewOrders_active__YUMNN {
  color: #fe6100;
  border-bottom: 3px solid #FE6100; }

.previewOrders_noActive__PllBL {
  color: #212121;
  border-bottom: 3px solid #FFFFFF; }
  .previewOrders_noActive__PllBL:active span {
    color: #b62f00; }
  .previewOrders_noActive__PllBL:hover {
    background: rgba(254, 97, 0, 0.1);
    border-bottom: 3px solid rgba(254, 97, 0, 0.1); }
    .previewOrders_noActive__PllBL:hover span {
      color: #fe6100; }
`, "",{"version":3,"sources":["webpack://./src/pages/previewOrders/previewOrders.module.scss","webpack://./src/styles/fonts.scss","webpack://./src/styles/media.scss"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B,EAAA;EAC9B;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,2BAA2B;IAC3B,WAAW;IACX,YAAY,EAAA;IANb;MAQG,YAAW,EAAA;EAGf;ICjBA,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IDiBf,2BAA2B,EAAA;EAE7B;IACE,aAAa,EAAA;IACb;MACE,iBAAiB;MACjB,mBAAmB,EAAA;IAErB;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS,EAAA;;AAKf;EACE,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS,EAAA;EACT;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS,EAAA;IACT;MCnCF,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MDmCb,2BAA2B,EAAA;IAE7B;MACE,yBAAyB,EAAA;IAE3B;MClBF,gBAAgB;MAChB,eAAe;MACf,iBAAiB;MDkBb,4BAA4B;MAC5B,kBAAkB;MAClB,gBAAgB,EAAA;MAChB;QACE,qBAAqB;QACrB,oBAAoB,EAAA;;AAM5B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS,EAAA;;AEvDT;EF2DA;IAEI,mBAAmB,EAAA,EACpB;;AEzDH;EF6DA;IAEI,mBAAmB,EAAA,EACpB;;AAIL;EACE,MAAM;EACN,QAAQ;EACR,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,sCAAsC,EAAA;EAEtC;IAbF;MAcI,WAAW,EAAA,EAEd;;AAED;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS,EAAA;;AAGX;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB,EAAA;EAPtB;IASI,oBAAoB,EAAA;;AAGxB;EACE,cAAc;EACd,gCAAgC,EAAA;;AAElC;EACE,cAAc;EACd,gCAAgC,EAAA;EAFlC;IAKM,cAAc,EAAA;EALpB;IASI,iCAAiC;IACjC,8CAA8C,EAAA;IAVlD;MAYM,cAAc,EAAA","sourcesContent":["@import '../../styles/media.scss';\n@import '../../styles/fonts.scss';\n\n.header {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  &__settings{\n    margin-left: 7px;\n    color: #666666;\n    cursor: pointer;\n    transition: all 0.4s linear;\n    width: 32px;\n    height: 32px;\n    &:hover{\n      color:black;\n    }\n  }\n  &_title {\n    @include h1;\n    color: var(--HightEmphasis);\n  }\n  &_container {\n    display: flex;\n    &_date {\n      margin-left: 10px;\n      padding-right: 30px;\n    }\n    &_filters {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n    }\n  }\n}\n\n.body {\n  height: calc(100vh - 190px);\n  display: flex;\n  flex-direction: column;\n  padding: 20px 0 0 0;\n  gap: 10px;\n  &_error {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    &_title {\n      @include h3;\n      color: var(--HightEmphasis);\n    }\n    &_icon {\n      color: var(--LowEmphasis);\n    }\n    &_subtitle {\n      @include body1;\n      color: var(--MediumEmphasis);\n      text-align: center;\n      max-width: 320px;\n      &_link {\n        text-decoration: none;\n        color: var(--Orange);\n      }\n    }\n  }\n}\n\n.error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 36px;\n}\n\n@include md {\n  .content {\n    .header {\n      flex-direction: row;\n    }\n  }\n}\n@include lg {\n  .content {\n    .body {\n      flex-direction: row;\n    }\n  }\n}\n\n.menu {\n  top: 0;\n  right: 0;\n  height: 100vh;\n  width: 35vw;\n  position: relative;\n  background-color: #be8b7b;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 10rem 0;\n  transition: transform 0.3s ease-in-out;\n\n  @media (max-width: 600px) {\n    width: 100%;\n  }\n}\n\n.tabs1 {\n  position: relative;\n  display: flex;\n  gap: 20px;\n}\n\n.tab {\n  padding: 15px 8px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n  text-decoration: none;\n  transition: all 0.4s;\n  span{\n    transition: all 0.4s;\n  }\n}\n.active {\n  color: #fe6100;\n  border-bottom: 3px solid #FE6100;\n}\n.noActive {\n  color: #212121;\n  border-bottom: 3px solid #FFFFFF;\n  &:active {\n    span {\n      color: #b62f00;\n    }\n  }\n  &:hover {\n    background: rgba(254, 97, 0, 0.1);\n    border-bottom: 3px solid rgba(254, 97, 0, 0.1);\n    span {\n      color: #fe6100;\n    }\n  }\n}","@mixin h1 {\n  font-weight: 600;\n  font-size: 32px;\n  line-height: 150%;\n}\n\n@mixin h2 {\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 150%;\n}\n\n@mixin h3 {\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 24px;\n}\n\n@mixin h4 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin h5 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin h6 {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin body1 {\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin body2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 24px;\n}\n\n@mixin body3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n}\n\n@mixin link1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n@mixin link2 {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n}\n\n@mixin caption {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 24px;\n}\n\n@mixin title {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 150%;\n}\n\n@mixin button {\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 24px;\n}\n","$xs: 0px;\n$sm: 425px;\n$md: 768px;\n$lg: 1024px;\n$xl: 1440px;\n\n@mixin xs {\n  @media (min-width: $xs) {\n    @content;\n  }\n}\n@mixin sm {\n  @media (min-width: $sm) {\n    @content;\n  }\n}\n@mixin md {\n  @media (min-width: $md) {\n    @content;\n  }\n}\n@mixin lg {\n  @media (min-width: $lg) {\n    @content;\n  }\n}\n@mixin xl {\n  @media (min-width: $xl) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `previewOrders_header__hz7Ou`,
	"header__settings": `previewOrders_header__settings__zOySh`,
	"header_title": `previewOrders_header_title__yWbcc`,
	"header_container": `previewOrders_header_container__F4tm7`,
	"header_container_date": `previewOrders_header_container_date__f4fdX`,
	"header_container_filters": `previewOrders_header_container_filters__NIu4I`,
	"body": `previewOrders_body__4D2dY`,
	"body_error": `previewOrders_body_error__kkmbc`,
	"body_error_title": `previewOrders_body_error_title__g0Fqa`,
	"body_error_icon": `previewOrders_body_error_icon__Chfth`,
	"body_error_subtitle": `previewOrders_body_error_subtitle__x+Zf8`,
	"body_error_subtitle_link": `previewOrders_body_error_subtitle_link__GUpka`,
	"error": `previewOrders_error__oQaFU`,
	"content": `previewOrders_content__DnChL`,
	"menu": `previewOrders_menu__glqXY`,
	"tabs1": `previewOrders_tabs1__Lnnk2`,
	"tab": `previewOrders_tab__oZOox`,
	"active": `previewOrders_active__YUMNN`,
	"noActive": `previewOrders_noActive__PllBL`
};
export default ___CSS_LOADER_EXPORT___;
